"use client";

import { useAppDispatch, useAppStore } from "@/redux/hooks";
import { setToolType, setToolsData, setToolContentData } from "@/components/ToolsPage/redux/slice";
import { ToolsState } from "@/components/ToolsPage/redux/types";

const useSyncToolsData: (data: { toolsInfo: ToolsState; toolSlug: string }) => void = ({ toolsInfo, toolSlug }) => {
  const dispatch = useAppDispatch();
  const store: any = useAppStore();

  const { toolData, content } = toolsInfo;

  if (store?.getState()?.tools?.type !== toolSlug) {
    dispatch(setToolsData(toolData));
    dispatch(setToolType(toolSlug));
    dispatch(setToolContentData(content));
  }
};

export { useSyncToolsData };
